import { IconBase } from './IconBase'

type IconTwitterProps = React.ComponentProps<'svg'>

export const IconTwitter = (props: IconTwitterProps) => {
  return (
    <IconBase width="1em" viewBox="0 0 24 24" {...props}>
      <path
        d="M22.86 5.152a.5.5 0 0 0-.569-.107l-.082.038-.209.095c.204-.324.365-.671.477-1.03a.5.5 0 0 0-.737-.575 7.392 7.392 0 0 1-1.685.77A4.732 4.732 0 0 0 16.75 3 4.75 4.75 0 0 0 12 7.75V8l-.5-.04C6.64 7.385 5.255 4.115 5.197 3.974a.75.75 0 0 0-1.228-.255C3.87 3.82 3 4.74 3 6.5c0 1.254.56 2.271 1.283 3.062a4.547 4.547 0 0 1-.538-.377.752.752 0 0 0-1.241.633c.01.106.222 2.107 2.534 3.617l-.422.077A.75.75 0 0 0 4.15 14.7c.052.07 1.029 1.34 3.15 2.07-1.133.378-2.69.73-4.55.73a.75.75 0 0 0-.565 1.244C2.265 18.835 4.217 21 9.25 21c8.356 0 12.25-7.758 12.25-13v-.25c0-.074-.008-.146-.011-.22 1.046-1.01 1.44-1.769 1.458-1.807a.5.5 0 0 0-.088-.57Z"
        fill="#fff"
      />
    </IconBase>
  )
}
